export default __webpack_public_path__ + "static/bg-branding-tomo-5fa75dea4de9e4daab6471d412eba538.png";